import React from 'react';
import GestionAPIExterne from '../../components/dashboards/components/GestionAPIExterne';

const APIExterne = () => {
  return <GestionAPIExterne />;
};

export default APIExterne;
